export default __webpack_public_path__ + "static/media/weather.f6f0c96d.PNG";